import React, { useEffect } from "react";
import dayjs from "dayjs";

interface ReactivateCampaignModalProps {
  isOpen: boolean;
  endDate?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const ReactivateCampaignModal: React.FC<ReactivateCampaignModalProps> = ({
  isOpen,
  endDate,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    const previousTouchAction = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.touchAction = previousTouchAction;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const formattedEndDate = endDate
    ? dayjs(endDate).format("MMM D, YYYY")
    : "the selected date";

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:p-4 overflow-y-auto"
      onClick={onCancel}
    >
      <div
        className="relative w-full max-w-[796px] z-[111] rounded-2xl sm:rounded-3xl md:rounded-[40px] p-[1px] flex-shrink-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(130,135,152,0) 0%, rgba(130,135,152,0.4) 100%)",
        }}
      >
        <div
          className="relative w-full overflow-hidden rounded-2xl sm:rounded-3xl md:rounded-[40px] bg-[#0e0e10] min-h-[274px] md:min-h-[296px] shadow-[0px_20px_40px_rgba(0,0,0,0.28)]"
          onClick={(event) => event.stopPropagation()}
        >
          <div
            className="pointer-events-none absolute left-1/2 top-[-84px] h-[140px] w-[440px] -translate-x-1/2 opacity-90 blur-[52px] md:top-[-112px] md:h-[170px] md:w-[450px]"
            style={{
              background:
                "linear-gradient(226deg, #1B76FF 12%, #2BFAA3 94%)",
            }}
          />

          <div className="relative z-10 flex min-h-[274px] flex-col items-center justify-center px-6 py-10 text-center md:min-h-[296px] md:px-16 md:py-12">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-white text-[24px] lg:text-[32px] font-semibold">
                Reactivate campaign
              </h2>
              <p className="mt-4 max-w-[470px] text-white/70 text-[16px] lg:text-[20px] leading-[130%] font-normal">
                This campaign ended on {formattedEndDate}
                <br />
                To resume, update the schedule
              </p>

              <button
                onClick={onConfirm}
                className="mt-12 inline-flex h-[48px] w-full lg:w-[286px] items-center justify-center rounded-full bg-white text-[14px] lg:text-[16px] font-medium text-[#020202]"
              >
                Edit ad campaign schedule
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReactivateCampaignModal;
